[
	{
		"title": "Policy Number",
		"align": "text-center",
		"key": "policyNumber"
	},
	{
		"title": "Risk State",
		"align": "text-center",
		"key": "riskState"
	},
	{
		"title": "Status Code",
		"align": "text-center",
		"key": "statusCode"
	},
	{
		"title": "LOB",
		"align": "text-center",
		"key": "lineOfBusinessCode"
	},
	{
		"title": "Effective Date",
		"align": "text-center",
		"key": "effectiveDate"
	},
	{
		"title": "Current Premium",
		"align": "text-right",
		"key": "totalPremium"
	},
	{
		"title": "MoE Rating",
		"align": "text-right",
		"key": "newPremium"
	}
]